import { SupportPage } from "./Support";

export default function AdminSupport() {
  return <SupportPage isAdmin={true} />;
}
